module.exports = __webpack_public_path__ + "img/right1.1d5730c6.png";